<template>

    <v-modal title="Push">

        <template #body>
            <v-alert :message="error" />
            <v-alert type="info" can-close>To send web push notifications, be sure to <a href="https://docs.crowdpower.io/resources/push-notifications" target="_blank">follow these instructions</a>.</v-alert>
            <v-form-group dir="ver" label="Title">
                <v-input :model="params.subject" @input="params.subject = $event" />
            </v-form-group>
            <v-form-group dir="ver" label="Body">
                <v-textarea-variable :model="params.body" @input="params.body = $event" />
            </v-form-group>
            <v-form-group dir="ver" label="URL">
                <v-input placeholder="https://" :model="params.url" @input="params.url = $event" />
            </v-form-group>
        </template>

        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="saveAction">Save</v-button>
        </template>

    </v-modal>

</template>

<script>

import ModalActionMixin from '@mixins/ModalActionMixin';

export default {

    mixins: [ModalActionMixin],

    data() {
        return {
            params: {
                type: this.action.type,
                subject: this.action.subject,
                body: this.action.body,
                url: this.action.url,
            },
        }
    },

}

</script>
